import React, { useState } from "react";
import ButtonH1 from './ApiCallButton';
import FeatherIcon from 'feather-icons-react';
import { useBrandVoice } from '../contexts/BrandVoiceContext';
import SettingsPanel from './SettingsPanel';

export default function ChooseTrend({ change, onResponse, trendData, originalKeyword }) {
    const [displayCount, setDisplayCount] = useState(5);
    const { getBlogGenerationPayload } = useBrandVoice();

    const handleResponse = (rData, iData) => {
      onResponse(rData, iData);
      change();
    };

    const handleShowMore = () => {
      setDisplayCount(prev => Math.min(prev + 5, trendData.length));
    };

    const generateButton = trendData.slice(0, displayCount).map((trend, index) => {
      return(
        <ButtonH1 
          url="/openai-h1"
          promptType="trend_topic"
          iData={trend.query}
          originalKeyword={originalKeyword}
          brandVoiceSettings={getBlogGenerationPayload()}
          onResponse={handleResponse}
          key={index}
          label={trend.query}
          value={trend.value}
        />
      )
    });
  
    return(
      <div className='choose'>
        <h1>Choose Google Trend</h1>
        <h2>Nothing there? skip fast!</h2>
        <div className="trend-count">
          Showing {displayCount}/{trendData.length} trends
        </div>
        {generateButton}
        {displayCount < trendData.length && (
          <button 
            className="show-more-btn"
            onClick={handleShowMore}
          >
            <FeatherIcon icon="chevron-down" size={24} />
            Show More
          </button>
        )}
        <SettingsPanel />
      </div>
    )
}

